import _ from 'lodash'

export const getBookFormats = (bookFormats, data) => {
	let availableFormats = data.allPublishFormats.nodes

	return _.filter(availableFormats, (format) => {
		if (_.find(bookFormats, { name: format.name })) return format
	})
}